angular.module('bmsApp.settings')
	.controller('OnlineStatusCtrl', OnlineStatusCtrl);

OnlineStatusCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$filter',
	'InstanceSvc',
	'LicenseOptionsSvc',
	'AppSettingsSvc',
	'OnlineTermsSvc',
	'MMOnlineProductSvc',
	'OnlineSlotsSvc',
	'OnlineDiscountSvc',
	'OnlineSaleStatusSvc',
	'ZoneSvc',
	'SMCleaningServiceSvc',
];

function OnlineStatusCtrl($scope,
						  $state,
						  $q,
						  $filter,
						  InstanceSvc,
						  LicenseOptionsSvc,
						  AppSettingsSvc,
						  OnlineTermsSvc,
						  MMOnlineProductSvc,
						  OnlineSlotsSvc,
						  OnlineDiscountSvc,
						  OnlineSaleStatusSvc,
						  ZoneSvc,
						  SMCleaningServiceSvc,
) {

	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
	});

	self.ecomSteps = [
		// {
		// 	value: 'terms',
		// 	label: 'Terms and Conditions',
		// 	desc: 'Provide your online terms and conditions and important notes',
		// 	setupState: 'main.settings.online-terms',
		// 	completed: false,
		// 	mandatory: true,
		// 	weight: 300,
		// },
		{
			value: 'alerts',
			label: 'Alert destinations',
			desc: 'Specify an email and mobile number to be alerted when new e-commerce jobs arrive',
			setupState: 'main.settings.online-alert-destination',
			completed: false,
			mandatory: false,
			weight: 600,
		},
	];

	this.$onInit = () => {
		if (InstanceSvc.instance.isMM() || InstanceSvc.instance.isTG()) {
			self.ecomSteps.push({
				value: 'slots',
				label: 'Online slots',
				desc: 'Online slots must be provided so that your customers can select their availability when making a purchase',
				setupState: 'main.settings.online-slots',
				completed: false,
				mandatory: true,
				weight: 350,
			})
		}

		if (InstanceSvc.instance.isSM() || InstanceSvc.instance.isMM()) {
			self.ecomSteps.push({
				value: 'stripe',
				label: 'Stripe payment gateway',
				desc: 'Setup your stripe payment gateway account',
				completed: false,
				setupState: 'main.settings.stripe-configuration',
				mandatory: true,
				weight: 100,
			});
			self.ecomSteps.push({
				value: 'services',
				label: 'Products / Services',
				desc: 'Setup your products and services you wish to make available online',
				setupState: InstanceSvc.instance.isSM() ? 'main.settings.smCleaningServices' : 'main.settings.mm-online-products',
				completed: false,
				mandatory: true,
				weight: 200,
			});
			self.ecomSteps.push({
				value: 'discounts',
				label: 'Online discounts',
				desc: 'You may wish to setup some discount codes which your customers can use at your checkout',
				setupState: 'main.settings.online-discounts',
				completed: false,
				mandatory: false,
				weight: 400,
			});
		}
		if (InstanceSvc.instance.isSM() || InstanceSvc.instance.isTG()) {
			self.ecomSteps.push({
				value: 'zones',
				label: 'Zones',
				desc: 'You may wish to setup zones to make your scheduling more effective',
				setupState: 'main.zone',
				completed: false,
				mandatory: false,
				weight: 500,
			});
		}

		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	function checkStatus() {

		let promises = {
			status: OnlineSaleStatusSvc.read({licenseId: self.license.id}),
			settings: AppSettingsSvc.index(),
			// terms: OnlineTermsSvc.read(self.license.id),
		};

		if (InstanceSvc.instance.isMM()) {
			angular.extend(promises, {
				mm_services: MMOnlineProductSvc.index({licenseId: self.license.id})
			});
		}

		if (InstanceSvc.instance.isSM()) {
			angular.extend(promises, {
				sm_services: SMCleaningServiceSvc.options({licenseId: self.license.id, onlineOnly: true}),
			});
		}

		if (InstanceSvc.instance.isMM() || InstanceSvc.instance.isTG()) {
			angular.extend(promises, {
				slots: OnlineSlotsSvc.index({filter: {license: self.license.id},  inFuture: true})
			});
		}

		if (InstanceSvc.instance.isMM() || InstanceSvc.instance.isSM()) {
			angular.extend(promises, {
				discounts: OnlineDiscountSvc.index({filter: {valid: true}})
			});
		}

		if (InstanceSvc.instance.isSM() || InstanceSvc.instance.isTG()) {
			angular.extend(promises, {
				zones: ZoneSvc.index(),
			});
		}

		self.loading = true;
		$q.all(promises).then((responses) => {
			self.saleStatus = responses.status.data.sale_status;
			// Stripe
			self.settingData = responses.settings.data.settings;

			// Alert destinations
			updateStatus('alerts', (self.settingData.ecom_alert_email || self.settingData.ecom_alert_sms));

			// // Terms
			// self.term = responses.terms.data.term;
			// updateStatus('terms', angular.isObject(self.term));

			// MM Services
			if (InstanceSvc.instance.isMM()) {
				self.mm_services = responses.mm_services.data.services;
				self.custom_mm_services = responses.mm_services.data.custom_services;
				let enabledServices = $filter('filter')(self.mm_services, {is_enabled: true}, true);
				let customEnabledServices = $filter('filter')(self.custom_mm_services, {is_enabled: true}, true);
				updateStatus('services', enabledServices.length || customEnabledServices.length);
			}

			// SM Services
			if (InstanceSvc.instance.isSM()) {
				self.sm_services = responses.sm_services.data.cleaning_service_options;
				updateStatus('services', self.sm_services.length);
			}

			// Slots
			if (InstanceSvc.instance.isMM() || InstanceSvc.instance.isTG()) {
				self.slots = responses.slots.data.collection;
				updateStatus('slots', self.slots.length);
			}

			// Discounts
			if (InstanceSvc.instance.isMM() || InstanceSvc.instance.isSM()) {
				self.discounts = responses.discounts.data.collection;
				updateStatus('discounts', self.discounts.length);
				updateStatus('stripe', self.settingData.stripe_validated);
			}

			// Discounts
			if (InstanceSvc.instance.isSM() || InstanceSvc.instance.isTG()) {
				self.zones = responses.zones.data.zone_collection;
				updateStatus('zones', self.zones.length);
			}

			isReadyToSell();

			self.loading = false;

		});

	}

	function updateStatus(key, value, meta) {
		let updated = false;
		let step = $filter('filter')(self.ecomSteps, {value: key}, true);
		if (step.length === 1) {
			let stepSelected = step[0];
			stepSelected.completed = value;
			updated = true;
		}
		else {
			throw "UpdateStatus(): No such key";
		}
		return updated;
	}

	function isReadyToSell() {
		let stepsRequired = $filter('filter')(self.ecomSteps, {mandatory: true}, true);
		let stepsCompleted = 0;
		angular.forEach(self.ecomSteps, (step) => {
			if (step.mandatory && step.completed) {
				stepsCompleted++;
			}
		});

		self.isReadyToSell = stepsCompleted === stepsRequired.length;
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.licenseChanged = () => {
		checkStatus();
	};

	handlers.goToSetup = (step) => {
		$state.go(step.setupState);
	};

	handlers.readyToSellClick = () => {
		let params = {
			licenseId: self.license.id,
			is_ready: true,
		};

		OnlineSaleStatusSvc.save(params).then((response) => {
			self.saleStatus = response.data.sale_status;
		});
	};
}
